<template>
    <YesNo class="mb-4" :label="schema.label" :question="schema.question" color="blue" :value="value" @input="$emit('change', $event)"/>
</template>

<script>

import YesNo from '@/ui-elements/YesNo'

export default {

    data() {
        return {
        
        }
    },

    components: {
        YesNo, 
    },
    
    props: {
        value: String,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// YesNoControl.vue?f25f3972